var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpiringLicense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/120/CancelExpiring License") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/120/CancelExpiring-License",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-cancel-membership"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.73, 11.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.66,69.84 L8.69,69.84 C3.89,69.84 0,65.78 0,60.77 L0,9.07 C0,4.06 3.89,0 8.69,0 L95.61,0 C100.41,0 104.3,4.06 104.3,9.07 L104.3,52.09",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 26.29,
    cy: 26.36,
    r: 7.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.65,46.21 L13.92,46.21 C13.92,39.38 19.45,33.85 26.28,33.85 C33.11,33.85 38.64,39.38 38.64,46.21 L38.65,46.21 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.31,
    y1: 24.8,
    x2: 77.59,
    y2: 24.8,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.31,
    y1: 33.19,
    x2: 77.59,
    y2: 33.19,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.31,
    y1: 42.32,
    x2: 77.59,
    y2: 42.32,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.66, 47.06)",
    id: "Oval",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.44,
    cy: 25.44,
    r: 25.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(86.5063, 58.8505)",
    fill: "#FF7900"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,0 C1.119,0 0,1.119 0,2.5 L0,15.27 C0,16.65 1.119,17.77 2.5,17.77 C3.881,17.77 5,16.65 5,15.27 L5,2.5 C5,1.119 3.881,0 2.5,0",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8926,22.1904 C3.7526,22.1004 3.6026,22.0204 3.4536,21.9604 C3.3026,21.8904 3.1426,21.8504 2.9936,21.8104 C2.1726,21.6504 1.3126,21.9194 0.7336,22.5004 C0.2626,22.9604 0.0026,23.6104 0.0026,24.2594 C0.0026,24.4304 0.0126,24.5894 0.0526,24.7504 C0.0826,24.9104 0.1326,25.0704 0.1936,25.2204 C0.2526,25.3704 0.3326,25.5204 0.4226,25.6504 C0.5126,25.7904 0.6136,25.9194 0.7336,26.0304 C0.8526,26.1504 0.9726,26.2504 1.1136,26.3394 C1.2436,26.4304 1.3926,26.5094 1.5426,26.5704 C1.6936,26.6404 1.8526,26.6804 2.0126,26.7104 C2.1726,26.7504 2.3326,26.7594 2.5026,26.7594 C2.6636,26.7594 2.8236,26.7504 2.9936,26.7104 C3.1426,26.6804 3.3026,26.6404 3.4536,26.5704 C3.6026,26.5094 3.7526,26.4304 3.8826,26.3394 C4.0226,26.2504 4.1536,26.1504 4.2626,26.0304 C4.3826,25.9194 4.4836,25.7904 4.5736,25.6504 C4.6636,25.5204 4.7436,25.3704 4.8026,25.2204 C4.8726,25.0704 4.9136,24.9104 4.9536,24.7504 C4.9836,24.5894 4.9936,24.4304 4.9936,24.2594 C4.9936,23.6004 4.7336,22.9604 4.2626,22.5004 C4.1536,22.3794 4.0226,22.2804 3.8926,22.1904",
    id: "Fill-9"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiringLicense);
export default __webpack_public_path__ + "static/media/expiring_license.3467ed7ea02f122aaa9bd48993f590eb.svg";
export { ForwardRef as ReactComponent };